import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// 🎯 FIXED PATH: Up 4 levels to reach src/common
import { useNavigationContext } from "../../../../common/navigation/NavigationContext";

// 🎯 FIXED PATHS: Reaching the controllers folder
import TemplateInventoryController from "../controllers/TemplateInventoryController";
import TemplateHeaderController from "../controllers/TemplateHeaderController";

export default function TemplateBuilderMainView() {
  const navigate = useNavigate();
  const { activeWorkflow } = useNavigationContext();
  
  const [step, setStep] = useState(1);
  const [context, setContext] = useState({
    selectedFile: null,
    header: null
  });

  const PageShell = ({ children, title, subtitle, isWide = false }) => (
    <main id="main" className="page-main mt-5 pt-5" data-scroll-container>
      <div className="page-main-inner">
        <section className="page-section px-4">
          <div className={isWide ? "container-fluid" : "container"}>
            <div className="row justify-content-center">
              <div className={isWide ? "col-12" : "col-xl-8"}>
                <div className="d-flex justify-content-between align-items-end mb-4 border-bottom pb-3">
                  <div>
                    <h2 className="h4 fw-bold mb-1 text-dark">
                        {activeWorkflow?.name || "Template Builder"}
                    </h2>
                    <div className="text-muted extra-small text-uppercase fw-bold">{subtitle}</div>
                  </div>
                </div>

                {children}

                <div className="mt-5 pt-4 border-top d-flex justify-content-between align-items-center">
                  <button
                    type="button"
                    className="btn btn-link text-decoration-none p-0 text-secondary small d-flex align-items-center"
                    onClick={() => navigate("/registered/site-admin/taxonomy-workflow")}
                  >
                    <i className="bi bi-arrow-left me-2"></i>
                    Return to Refresh ESG Taxonomy
                  </button>
                  <span className="text-muted small italic">Step {step} of 3</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );

  if (step === 1) {
    return (
      <PageShell subtitle="Step 1: Select Source Taxonomy">
        <TemplateInventoryController 
          onConfirm={(file) => {
            setContext({ ...context, selectedFile: file });
            setStep(2);
          }} 
        />
      </PageShell>
    );
  }

  if (step === 2) {
    return (
      <PageShell subtitle="Step 2: Define Template Metadata">
        <TemplateHeaderController 
          sourceFile={context.selectedFile}
          onHeaderGenerated={(headerData) => {
            setContext({ ...context, header: headerData });
            setStep(3);
          }}
          onBack={() => setStep(1)}
        />
      </PageShell>
    );
  }

  return (
    <PageShell subtitle={`Active Root: ${context.selectedFile.filename}`} isWide={true}>
      <div className="card shadow-sm border-0 p-5 bg-white text-center border-dashed">
        <div className="py-5">
            <div className="spinner-grow text-primary mb-3"></div>
            <h5 className="text-muted italic fw-normal">[Builder Engine Initializing for {context.header.name}...]</h5>
        </div>
      </div>
    </PageShell>
  );
}